export const formatSkillLabel = (value: string): string =>
  value.replace(/C Sharp/g, 'C#');
